module.exports = __webpack_public_path__ + "media/auto_history/kupno-195129e1.png";